import React, { Fragment, useEffect, useState } from 'react';
import {
  Row,
  Col,
  Card,
  FormGroup,
  CardBody,
  Button,
  Input,
  Spinner,
  CustomInput,
  Label,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
  API_External_Source,
  gAPI_Users_By_Id,
  API_RMS,
  gAPI_RMS,
  API_RMS_SYNC_ROOMS,
} from '../../../../../constants/APIs';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import sync_rezdy from '../../../../../assets/sync_rezdy.png';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Select from 'react-select';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
const RMSForm = ({
  propertyId,
  email,
  rmsIntegration,
  submit,
  LoadData,
  rmsData,
}) => {
  const [selectedRMSProperties, setSelectedRMSProperties] = useState([]);
  const [open, setOpen] = useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [msg, setMsg] = useState([]);
  const [configurations, setConfigurations] = useState([]);
  const [clientProperties, setClientProperties] = useState([]);
  const [sourceData, setSourceData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    createdBy: 'Admin',
    sourceStatus: 'Active',
    sourceType: 'RMS',
    name: '',
    frequency: 'Weekly',
    webPages: [],
    faqList: [],
    rmsConfiguration: {
      guestRooms: false,
      propertyId: '',
    },
    enableFAQ: false,
    email: email,
  });
  useEffect(() => {
    let rmsProperties = [];
    if (rmsData?.id) {
      AxiosAPI({
        method: 'get',
        url: `${API_External_Source}/${rmsData?.id}`,
      }).then((res) => {
        const data = res.data;
        if (data.rmsConfiguration === null) {
          data.rmsConfiguration = {
            guestRooms: false,
            languages: [],
          };
        }

        // let lst = [];
        // let selectedList = [];
        // if (propertyLanguages != undefined && propertyLanguages.length > 0) {
        //   propertyLanguages.map((m) =>
        //     lst.push({ key: m, value: m, label: m })
        //   );
        //   propertyLanguages
        //     .filter(
        //       (f) =>
        //         data.rmsConfiguration.languages.length > 0 &&
        //         data.rmsConfiguration.languages.filter((l) => l == f).length > 0
        //     )
        //     .map((m) => selectedList.push({ key: m, value: m, label: m }));
        // }
        // setSelectedLanguages(selectedList);
        // setLanguageOptions(lst);
        setSourceData({
          ...data,
          name: 'RMS Sync',
          groupId: getGroupID(),
          propertyId: propertyId,
          createdBy: 'Admin',
          email: email,
        });
      });
    } else {
      // let lst = [];
      // if (propertyLanguages != undefined && propertyLanguages.length > 0)
      //   propertyLanguages.map((m) => lst.push({ key: m, value: m, label: m }));
      // setLanguageOptions(lst);
    }    
    if (rmsIntegration !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_RMS}/${rmsIntegration?.id}?group_id=${getGroupID()}`,
      })
        .then((json) => {
          setIsLoading(true);          
          AxiosAPI({
            method: 'get',
            url: `${gAPI_RMS}/client-details?client_id=${json.data?.channelDetails?.clientId}&client_secret=${json.data?.channelDetails?.clientSecret}`,
          }).then((res) => {
            if (res.data.properties.length > 0) {
              let selectedProperties = [];
              if (
                json.data?.channelDetails?.rmsProperties &&
                json.data?.channelDetails?.rmsProperties.length > 0
              ) {
                json.data?.channelDetails?.rmsProperties.map((m) => {
                  if (res.data.properties.filter((f) => f.id == m).length > 0) {
                    let obj = res.data.properties.filter((f) => f.id == m)[0];
                    selectedProperties.push({
                      key: obj.id,
                      label: obj.name + ' - ' + obj.id,
                      value: obj.id,
                    });
                  }
                });
              }
              if (json.data?.channelDetails?.propertyId) {
                if (
                  res.data.properties.filter(
                    (f) => f.id == json.data?.channelDetails?.propertyId
                  ).length > 0
                ) {
                  let obj = res.data.properties.filter(
                    (f) => f.id == json.data?.channelDetails?.propertyId
                  )[0];
                  selectedProperties.push({
                    key: obj.id,
                    label: obj.name + ' - ' + obj.id,
                    value: obj.id,
                  });
                }
              }
              setSelectedRMSProperties(selectedProperties.filter(f=> rmsProperties.includes(f.value)));
              setClientProperties(selectedProperties);
            }
          });
          setIsLoading(false);
        })
        .catch((err) => console.log('err', err));
    }
  }, [propertyId, rmsData]);

  useEffect(() => {
    let properties = clientProperties;
    let secondaryProperties = sourceData?.rmsConfiguration?.propertyId || [];
    setSelectedRMSProperties(properties.filter(f=> secondaryProperties.filter(s=>s == f.value).length > 0));    
  }, [clientProperties]);


  const handlermsConfiguration = (e) => {
    let configuration = { ...sourceData.rmsConfiguration };
    configuration[e.target.name] = e.target.checked;
    setSourceData({ ...sourceData, rmsConfiguration: configuration });
  };
  const handlermsConfigurationChange = (e) => {
    setSelectedRMSProperties(e);
    let lst = e.map((m) => m.value);
    let configuration = { ...sourceData.rmsConfiguration };
    configuration.propertyId = lst;
    setSourceData({ ...sourceData, rmsConfiguration: configuration });    
  };

  const handleChange = (e) => {
    setSourceData({ ...sourceData, [e.target.name]: e.target.value });
  };

  const handleSyncManualy = (item) => {    
    if (sourceData?.id !== undefined && sourceData?.id !== null) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
      }).then((res) => {
        AxiosAPI({
          method: 'put',
          url: `${API_External_Source}/${item.id}`,
          data: {
            userName: res.data.fullName,
            isManual: true,
            email: email,
          },
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            NotificationManager.success(
              '',
              'We have received your request. It will take few minutes.',
              3000,
              null,
              null,
              'success'
            );
            LoadData();
          }
        });
      });
    } else handleSave();
  };

  const handleSave = () => {
    const data = {
      ...sourceData,
      name: 'RMS Sync',
      groupId: getGroupID(),
      propertyId: propertyId,
      createdBy: 'Admin',
      email: email,
    };

    if (sourceData?.id) {
      AxiosAPI({
        method: 'put',
        url: `${API_External_Source}/${sourceData.id}`,
        data: data,
      })
        .then((res) => {
          NotificationManager.success('Updated successfully', '', 3000);
          LoadData();
        })
        .catch((err) => {
          NotificationManager.error('Update failed', '', 3000);
          console.error(err);
        });
    } else {
      console.log(JSON.stringify(sourceData));
      submit(sourceData);
    }
  };

  const handleSelect = (selectedOption) => {
    // setSelectedLanguages(selectedOption);
    let configuration = { ...sourceData.rmsConfiguration };
    //configuration['languages'] = selectedOption.map((m) => m.value);
    setSourceData({ ...sourceData, rmsConfiguration: configuration });
  };
  return (
    <Fragment>      
        <Colxx xs="12">
          <Card style={{ width: '100%', borderRadius: '1.25rem' }}>
            <CardBody>
              <Col md="12" className="mt-2 mb-3">
                <img
                //src={sync_sabre}
                // style={{ width: '100%', height: '90px' }}
                ></img>
              </Col>
              <Col md="12" className="mt-2 mb-3">
                <Row>
                  {/* <Colxx sm={4} className="mb-3">
                    <Label>
                      <IntlMessages id='dashboards.title' /> <span style={{ color: 'red' }}> *</span>
                    </Label>
                    <Input
                      value={sourceData.name}
                      name="name"
                      onChange={handleChange}
                      disabled
                    ></Input>
                  </Colxx> */}
                  <Colxx sm={3} className="mb-3">
                    <Label>
                      <IntlMessages id="pages.status" />{' '}
                      <span style={{ color: 'red' }}> *</span>
                    </Label>
                    <Input
                      type="select"
                      value={sourceData.status}
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Input>
                  </Colxx>
                  <Colxx sm={3} className="mb-3">
                    <Label>
                      <IntlMessages id="dashboards.frequency" />{' '}
                      <span style={{ color: 'red' }}> *</span>
                    </Label>
                    <Input
                      type="select"
                      value={sourceData.frequency}
                      name="frequency"
                      onChange={handleChange}
                    >
                      <option value="Weekly">Weekly</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Manually">Manually</option>
                    </Input>
                  </Colxx>
                  {clientProperties.length > 0 && (
                    <Colxx sm={5} className="mb-3">
                      <Label>
                        Property ID
                        <span style={{ color: 'red' }}> *</span>
                      </Label>
                      <Select
                        components={{ Input: CustomSelectInput }}
                        className="react-select"
                        classNamePrefix="react-select"
                        isMulti={true}
                        name="form-field-name"
                        value={selectedRMSProperties}
                        onChange={handlermsConfigurationChange}
                        options={clientProperties}
                      ></Select>
                      {/* <Input
                        type="select"
                        value={sourceData?.rmsConfiguration?.propertyId}
                        name="propertyId"
                        onChange={handlermsConfigurationChange}
                      >
                        <option value="">Select Property</option>
                        {selectedRMSProperties.map((property) => (
                          <option key={property.id} value={property.id}>
                            {property.name} - {property.id}
                          </option>
                        ))}
                      </Input> */}
                    </Colxx>
                  )}
                </Row>
                <p className="mb-2">
                  With integration to RMS, you can sync hotel description using
                  Channel Connect API's, along with rooms types from RMS.
                </p>
                <p className="mb-2">
                  All the imported data is then readily available to train the
                  AI model for AI Chatbot, AI Voice, Email, and Agent Assist.
                  Includes:
                </p>
              </Col>
              <Row className="ml-1">
                <Colxx md={5} className="mb-3">
                  <CustomInput
                    style={{ height: '2.5rem' }}
                    type="checkbox"
                    name="guestRooms"
                    checked={
                      sourceData?.rmsConfiguration?.guestRooms ? true : false
                    }
                    label="Room Types & Description"
                    placeholder="https://www.yourwebpage1.com"
                    onChange={(e) => handlermsConfiguration(e)}
                  />
                </Colxx>
              </Row>
              <Row className="ml-1">
                <Col md={12} className="mb-3 text-end">
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleSyncManualy(sourceData)}
                  >
                    <IntlMessages id="dashboards.sync" />
                  </Button>
                  <Button
                    color="secondary"
                    onClick={handleSave}
                    size="sm"
                    className="ml-3"
                  >
                    <span className="label">
                      {' '}
                      <IntlMessages id="dashboards.save" />
                    </span>
                  </Button>
                </Col>
              </Row>
              <Row></Row>
            </CardBody>
          </Card>
        </Colxx>      
    </Fragment>
  );
};
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps, {})(RMSForm));
